export function hyphenToHump (str) {
  return str.replace(/[-_](\w)/g, (all, letter) => {
    return letter.toUpperCase()
  })
}
